// Updated TranscriptBody.jsx - Now simpler, focuses on text selection and clipboard
import React, { useContext, useCallback } from 'react';
import CodeableContext from 'contexts/CodeableContext';
import CodeOperationsContext from 'contexts/CodeOperationsContext';
import TranscriptRenderer from './TranscriptRenderer';
import useCopyHandler from 'hooks/useCopyHandler';

const TranscriptBody = ({
  transcriptID,
  setParagraphRef,
  isPrint,
  hasEditPermission,
  bodyRef,
  title,
  transcriptData,
  coders,
  selectedExcerptId,
  select,
  page
}) => {
  const { onDeselect, onSelectText } = useContext(CodeableContext) || {};
  const { onExcerptSelected, getSubstring } = useContext(CodeOperationsContext) || {};

  useCopyHandler(select, getSubstring);

  const onSelectTranscriptText = useCallback((start, end) => {
    onSelectText(start, end, transcriptID, 'Transcript');
  }, [onSelectText, transcriptID]);

  const onParagraphClick = useCallback((start, end) => {
    onSelectTranscriptText(start, end);
    document.getSelection().removeAllRanges();
  }, [onSelectTranscriptText]);

  // Safety check: This component expects transcriptData to be provided
  // Parent components should handle loading states before rendering this
  if (!transcriptData?.body) {
    return null;
  }

  return (
    <TranscriptRenderer
      transcriptID={transcriptID}
      transcriptText={transcriptData.body}
      coders={coders}
      selectedExcerptId={selectedExcerptId}
      select={select}
      page={page}
      isPrint={isPrint}
      hasEditPermission={hasEditPermission}
      title={title}
      bodyRef={bodyRef}
      setParagraphRef={setParagraphRef}
      onSelectText={onSelectTranscriptText}
      onExcerptSelected={onExcerptSelected}
      onDeselect={onDeselect}
      onParagraphClick={onParagraphClick}
    />
  );
};

export default TranscriptBody;
